/**
 * @generated SignedSource<<1e8a3173cdd264a5f333480c5546c1a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTeamScheduleAdminScreenListData_Routine$data = ReadonlyArray<{
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
    };
  }>;
  readonly currentSchedule: {
    readonly __typename: "RoutineScheduleDaily";
    readonly isAllDay: boolean | null;
    readonly weekdays: ReadonlyArray<{
      readonly startTime: {
        readonly hour: number;
        readonly minute: number;
      } | null;
      readonly weekday: number;
    }>;
  } | {
    readonly __typename: "RoutineScheduleMonthly";
    readonly endDay: number | null;
    readonly startDay: number;
  } | {
    readonly __typename: "RoutineScheduleWeekly";
    readonly startWeekday: number | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItem_routine">;
  readonly " $fragmentType": "useTeamScheduleAdminScreenListData_Routine";
}>;
export type useTeamScheduleAdminScreenListData_Routine$key = ReadonlyArray<{
  readonly " $data"?: useTeamScheduleAdminScreenListData_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTeamScheduleAdminScreenListData_Routine">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useTeamScheduleAdminScreenListData_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleAdminItem_routine"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineScheduleDailyWeekday",
              "kind": "LinkedField",
              "name": "weekdays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weekday",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Time",
                  "kind": "LinkedField",
                  "name": "startTime",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hour",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "minute",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleDaily",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startWeekday",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleWeekly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            }
          ],
          "type": "RoutineScheduleMonthly",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "7e6a060fd4a16666fdddeead6fe7ee2d";

export default node;
